var exports = {
  "kL": "PiPOverlay.module__container___b1VmV2",
  "$I": "PiPOverlay.module__containerResizing___b1VmV2",
  "n_": "PiPOverlay.module__hoverOverlay___b1VmV2",
  "YQ": "PiPOverlay.module__containerInteractionActive___b1VmV2",
  "YL": "PiPOverlay.module__headerGradient___b1VmV2",
  "VW": "PiPOverlay.module__headerContent___b1VmV2",
  "LD": "PiPOverlay.module__headerLeft___b1VmV2",
  "q3": "PiPOverlay.module__returnToCallButton___b1VmV2",
  "fs": "PiPOverlay.module__returnToCallIcon___b1VmV2",
  "Qt": "PiPOverlay.module__returnToCallLabel___b1VmV2",
  "wY": "PiPOverlay.module__footerGradient___b1VmV2",
  "z8": "PiPOverlay.module__footerContent___b1VmV2",
  "PU": "PiPOverlay.module__footerLeft___b1VmV2",
  "zz": "PiPOverlay.module__streamerName___b1VmV2",
  "wV": "PiPOverlay.module__footerRight___b1VmV2",
  "ti": "PiPOverlay.module__spectatorBadge___b1VmV2",
  "Bh": "PiPOverlay.module__spectatorIcon___b1VmV2",
  "hP": "PiPOverlay.module__actionButton___b1VmV2",
  "P4": "PiPOverlay.module__disconnectButton___b1VmV2",
  "gE": "PiPOverlay.module__actionIcon___b1VmV2",
};

module.exports = exports;
